import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import Audio from '../../assets/icons/vc-audio.svg?react';
import NoAudio from '../../assets/icons/vc-no-audio.svg?react';
import { AudioDevicesOptions } from '../AudioDevicesOptions/AudioDevicesOptions';
import { useAudioInputOptions } from '../AudioDevicesOptions/useAudioInputOptions';
import { MeetControl, MeetControlProps } from './MeetControl';

export function AudioControl({
	disabled = false,
	$off = false,
	$withMenu = false,
	vMenuPadding = 0,
	onClick,
}: MeetControlProps) {
	const theme = useThemeContext();

	const {
		opened: openedAudioInputDevices,
		open: openAudioInputDevices,
		close: closeAudioInputDevices,
	} = useAudioInputOptions();

	return (
		<MeetControl
			disabled={disabled}
			$off={$off}
			$withMenu={$withMenu}
			$menuOpened={openedAudioInputDevices}
			openMenu={openAudioInputDevices}
			closeMenu={closeAudioInputDevices}
			vMenuPadding={vMenuPadding}
			menu={
				<AudioDevicesOptions/>
			}
			onClick={onClick}
			triggerDataTest="audio-devices-selector__trigger"
		>
			{$off || disabled ? (
				<NoAudio fill={'#ED576B'} />
			) : (
				<Audio
					fill={$withMenu ? theme.colors.brand.primary[300] : theme.colors.neutral[500]}
					onClick={onClick}
				/>
			)}
		</MeetControl>
	);
}
